/*Framework Imports*/
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
/*Third Party Imports*/
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";

/*Component Imports*/
import Home from "./pages/home/home";
import Validate from "./pages/validate/validate";

/*Component Declaration*/
const App = () => {
  return (
    /*Routes Declaration*/
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/validate/:memberId/:existingEmail/:existingPhone"
          element={<Validate />}
        />
      </Routes>
    </Router>
  );
};

/*Component Export*/
export default App;
